/* Maison Textile : ouvre le panneau « Comparer nos gammes » (snippets/mt-compare.liquid)
   depuis tout lien vers #comparer-nos-gammes, et à l'arrivée sur une URL qui porte ce #. */
(function () {
  var ID = 'comparer-nos-gammes';
  var dlg = document.getElementById(ID);
  if (!dlg || typeof dlg.showModal !== 'function') return;

  function open() {
    if (dlg.open) return;
    dlg.showModal();
    document.documentElement.classList.add('mt-compare-open');
    // sur téléphone, amener la matière de la page en premier plan
    var cur = dlg.querySelector('.mt-compare__card.is-current');
    var box = dlg.querySelector('.mt-compare__cards');
    if (cur && box && box.scrollWidth > box.clientWidth) box.scrollLeft = cur.offsetLeft - box.offsetLeft - 16;
  }
  function close() { if (dlg.open) dlg.close(); }

  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('mt-compare-open');
    if (location.hash === '#' + ID) history.replaceState(null, '', location.pathname + location.search);
  });
  // clic sur le fond (hors du contenu) = fermer
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.querySelectorAll('[data-mt-compare-close]').forEach(function (b) { b.addEventListener('click', close); });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#' + ID + '"]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  // Échap ferme le panneau même si une autre fenêtre du thème (newsletter) capte la touche
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dlg.open) { e.stopPropagation(); close(); }
  }, true);

  if (location.hash === '#' + ID) open();
})();
